'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getAppRootUrl, getPublicRootUrl } from '../../utils/urls';
import { getIsPublic } from '../../selectors/auth';
import CoreHSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
const languageCode = window.I18N_MANUAL_LANG;

const HSPageViewTracker = ({
  pathname
}) => {
  const isPublic = useSelector(getIsPublic);
  const urlRoot = isPublic ? getPublicRootUrl(languageCode) : getAppRootUrl();
  return /*#__PURE__*/_jsx(CoreHSPageViewTracker, {
    pathname: `${urlRoot}${pathname}`
  });
};

HSPageViewTracker.propTypes = {
  pathname: PropTypes.string.isRequired
};
export default HSPageViewTracker;